import React from 'react';
import CategoryList from 'components/CategoryList/CategoryList.react';
import DashboardView from 'dashboard/DashboardView.react';
import ParseApp from 'lib/ParseApp';
import PropTypes from 'prop-types';
import styles from './ApiConsole.scss';
import RESTConsole from './RESTConsole/RESTConsole.react';
import GraphQLConsole from './GraphQLConsole/GraphQLConsole.react';

class ApiConsole extends DashboardView {
  constructor() {
    super();
    this.section = 'Core';
    this.subsection = 'API Console';

    this.state = {};
  }

  renderSidebar() {
    const current = this.props.params.type || '';
    const categories = [{ name: 'REST Console', id: 'rest' }];

    // const { parseServerVersion } = this.context.currentApp;
    // const version = parseServerVersion.replace(/[^0-9\.]+/g, '').split('.');
    // const cVersion = Number((`${version[0]}.${version[1]}`).replace(/[^0-9\.]+/g, ''));
    // if (cVersion >= 3.5) { }


    categories.push({ name: 'GraphQL Console', id: 'graphql' });

    return (
      <CategoryList
        current={current}
        linkPrefix="api-console/"
        categories={categories} />
    );
  }

  renderContent() {
    const { currentApp } = this.context;
    const { type } = this.props.params;
    return (
      <div className={styles.settings_page}>
        {type === 'rest' && <RESTConsole currentApp={currentApp} />}
        {type === 'graphql' && <GraphQLConsole currentApp={currentApp} />}
      </div>
    );
  }
}

ApiConsole.contextTypes = {
  generatePath: PropTypes.func,
  currentApp: PropTypes.instanceOf(ParseApp),
};

export default ApiConsole;
